<template>
  <div>
    <a-row type="flex" justify="end" class="mb-2">
      <a-button :disabled="!hasActiveFilters" @click="clearAllFilters">
        <template #icon><clear-outlined /></template>
        Limpiar filtros
      </a-button>
    </a-row>

    <div class="scroll-top" ref="scrollTop" @scroll="syncScrollTop">
      <div
        class="scroll-content"
        :style="{ width: tableScrollWidth + 'px' }"
      ></div>
    </div>

    <div class="scroll-bottom" ref="scrollBottom">
      <a-table
        :dataSource="tableData"
        :columns="tableColumns"
        :pagination="paginationProps"
        @change="changeCurrentPage"
        :loading="loadingTable"
        :scroll="{ x: 'max-content' }"
      >
        <!-- Modal de filtro de input -->
        <template #filterDropdown="{ column, confirm, clearFilters }">
          <div style="padding: 8px">
            <a-form
              name="form"
              layout="vertical"
              ref="formRef"
              :model="filterValues"
              :rules="rules"
            >
              <a-form-item has-feedback :name="column.dataIndex">
                <a-input
                  v-model:value="filterValues[column.key]"
                  @keyup="formatRuts"
                  :maxlength="column.dataIndex == 'companyRut' ? 12 : 40"
                  :placeholder="`Buscar por ${column.title}`"
                  @pressEnter="
                    handleSearch(
                      column.dataIndex,
                      filterValues[column.key],
                      confirm
                    )
                  "
                  style="width: 188px; margin-bottom: 8px; display: block"
                />
              </a-form-item>
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    filterValues[column.key],
                    confirm
                  )
                "
              >
                <template #icon><search-outlined /></template>
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </a-form>
          </div>
        </template>

        <!-- Modal de filtro de input -->
        <template #filterCompanies="{ column, confirm, clearFilters }">
          <div style="padding: 8px; width: 300px">
            <a-select
              v-model:value="selectedCompanies"
              :options="companies"
              mode="multiple"
              show-search
              :filterOption="true"
              optionFilterProp="label"
              placeholder="Buscar por Razón social"
              style="width: 100%"
            >
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <div
                  style="
                    border-top: 1px solid #f0f0f0;
                    display: flex;
                    justify-content: space-between;
                  "
                  class="p-2"
                  @mousedown="(e) => e.preventDefault()"
                >
                  <a-button
                    type="primary"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="
                      handleSearch(
                        column.dataIndex,
                        selectedCompanies.join(','),
                        confirm
                      )
                    "
                  >
                    Buscar
                  </a-button>

                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="handleColumnReset(column.dataIndex, clearFilters)"
                  >
                    Limpiar
                  </a-button>
                </div>
              </template>
            </a-select>
            <div
              class="mt-4 p-2"
              style="
                border-top: 1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
              "
            >
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    selectedCompanies.join(','),
                    confirm
                  )
                "
              >
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </div>
          </div>
        </template>

        <template #stateTag="{ text: tag }">
          <tag type="ticketGroup" :id="tag.id" :text="tag.text" />
        </template>

        <template #brokerName="{ record }">
          {{ record.brokerName }}
        </template>

        <!-- Filtros para estados -->

        <template #filterStates="{ confirm, column, clearFilters }">
          <div style="padding: 8px; width: 300px">
            <a-checkbox-group v-model:value="statesSelection">
              <a-row>
                <a-col
                  :span="24"
                  v-for="(state, index) in statesOptions"
                  :key="index"
                >
                  <a-checkbox :value="state.value">
                    {{ state.label }}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>

            <div
              class="mt-4 p-2"
              style="
                border-top: 1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
              "
            >
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    statesSelection.join(','),
                    confirm
                  )
                "
              >
                <template #icon><search-outlined /></template>
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </div>
          </div>
        </template>

        <!-- Tag de los estados -->
        <template #tag="{ text: tag }">
          <tag type="ticketGroup" :id="tag.id" :text="tag.text" />
        </template>

        <!-- Icono de filtrado de lupa -->
        <template #filterIcon="{ column }">
          <search-outlined
            :style="{
              color:
                searchValue[column.dataIndex] === undefined ||
                searchValue[column.dataIndex] === ''
                  ? undefined
                  : '#2521E5'
            }"
          />
        </template>

        <!-- Icono de filtrado para seleccion por checkbox -->
        <template #filterIconState="{ column }">
          <filter-outlined
            :style="{
              color:
                searchValue[column.dataIndex] === undefined ||
                searchValue[column.dataIndex] === ''
                  ? undefined
                  : '#2521E5'
            }"
          />
        </template>

        <template #filterBrokers="{ column, confirm, clearFilters }">
          <div style="padding: 8px; width: 300px">
            <a-select
              v-model:value="selectedBrokers"
              :options="brokers"
              mode="multiple"
              show-search
              :filterOption="true"
              optionFilterProp="label"
              placeholder="Buscar por ejecutivo"
              style="width: 100%"
              size="middle"
            >
              <template #dropdownRender="{ menuNode: menu }">
                <v-nodes :vnodes="menu" />
                <div
                  style="
                    border-top: 1px solid #f0f0f0;
                    display: flex;
                    justify-content: space-between;
                  "
                  class="p-2"
                  @mousedown="(e) => e.preventDefault()"
                >
                  <a-button
                    type="primary"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="
                      handleSearch(
                        column.dataIndex,
                        selectedBrokers.join(','),
                        confirm
                      )
                    "
                  >
                    Buscar
                  </a-button>

                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="handleColumnReset(column.dataIndex, clearFilters)"
                  >
                    Limpiar
                  </a-button>
                </div>
              </template>
            </a-select>
            <div
              class="mt-4 p-2"
              style="
                border-top: 1px solid #f0f0f0;
                display: flex;
                justify-content: space-between;
              "
            >
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  handleSearch(
                    column.dataIndex,
                    'broker_id',
                    selectedBrokers.join(','),
                    confirm
                  )
                "
              >
                Buscar
              </a-button>

              <a-button
                size="small"
                style="width: 90px"
                @click="handleColumnReset(column.dataIndex, clearFilters)"
              >
                Limpiar
              </a-button>
            </div>
          </div>
        </template>

        <!-- Detalles de intento fallido-->
        <template #details="{ text, record }">
          <template v-if="record.hasObservations">
            <a-tooltip :color="'#05045D'">
              <template #title>Ver observaciones</template>
              <a-button type="link" @click="openObservationsModal(record)">
                <warning-outlined class="text-error" />
              </a-button>
            </a-tooltip>
          </template>
          <template v-if="record.ticketGroupState?.id !== 6">
            <a-tooltip :color="'#05045D'">
              <template #title>Ver más</template>
              <router-link
                :to="{
                  name:
                    ticketType == 'Alta'
                      ? 'AltaMasivaDetail'
                      : ticketType == 'Baja'
                      ? 'BajaMasivaDetail'
                      : ticketType == 'Alta cargas'
                      ? 'AltaCargasMasivaDetalle'
                      : ticketType == 'Baja cargas'
                      ? 'BajaCargasMasivaDetalle'
                      : 'DetalleModificacionMasiva',
                  params: { id: text }
                }"
              >
                <eye-outlined />
              </router-link>
            </a-tooltip>
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <a-modal
    :wrapClassName="'modal-lg'"
    :title="modalProps.title"
    v-model:visible="modalProps.visible"
    @cancel="closeObservationsModal"
    :closable="!modalProps.loading"
    :maskClosable="!modalProps.loading"
    centered
  >
    <a-typography-text>
      Detalle de movimiento fallido, observaciones incluidas en el reporte:
    </a-typography-text>

    <a-descriptions
      class="mt-4"
      bordered
      :column="{ xs: 1, sm: 2 }"
      layout="horizontal"
      size="default"
      :label-style="{ fontWeight: 'bold' }"
      v-if="observationsTableData.length"
    >
      <a-descriptions-item label="Id">
        {{ observationsTableData[0].id }}
      </a-descriptions-item>

      <a-descriptions-item label="Empresa">
        {{ observationsTableData[0].company }}
      </a-descriptions-item>

      <a-descriptions-item label="Aseguradora">
        {{ observationsTableData[0].insuranceCompany }}
      </a-descriptions-item>

      <a-descriptions-item label="Ejecutivo">
        {{ observationsTableData[0].broker }}
      </a-descriptions-item>

      <a-descriptions-item label="Fecha de ingreso">
        {{ observationsTableData[0].createdAt }}
      </a-descriptions-item>

      <a-descriptions-item label="Archivo original">
        <a-tooltip
          color="#05045D"
          :title="`Descargar ${observationsTableData[0].movementFiles.fileMovement.name}`"
        >
          <a-button
            class="p-0"
            style="line-height: 1.4; height: auto"
            type="link"
            target="_blank"
            @click="
              downloadMovementFile(
                observationsTableData[0].movementFiles.fileMovement.id
              )
            "
          >
            {{
              formatFileName(
                observationsTableData[0].movementFiles.fileMovement.name
              ) || 'Descargar archivo'
            }}
          </a-button>
        </a-tooltip>
      </a-descriptions-item>

      <a-descriptions-item label="Reporte">
        <a-tooltip
          color="#05045D"
          :title="`Descargar ${observationsTableData[0].movementFiles.fileMovementProcess.name}`"
        >
          <a-button
            class="p-0"
            style="line-height: 1.4; height: auto"
            type="link"
            target="_blank"
            @click="
              downloadMovementProcessedFile(
                observationsTableData[0].movementFiles.fileMovementProcess.id
              )
            "
          >
            {{
              formatFileName(
                observationsTableData[0].movementFiles.fileMovementProcess.name
              ) || 'Descargar reporte'
            }}
          </a-button>
        </a-tooltip>
      </a-descriptions-item>

      <a-descriptions-item label="N° observaciones">
        {{
          observationsTableData[0].movementFiles.fileMovementProcess
            .numberOfObservations ?? 'Desconocido'
        }}
      </a-descriptions-item>
    </a-descriptions>

    <template #footer>
      <a-button
        type="primary"
        @click="closeObservationsModal"
        :disabled="modalProps.loading"
      >
        Cerrar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import {
  computed,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  watch,
  nextTick
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  getTicketGroupStates,
  getMovementFile,
  getMovementProcessedFile
} from '@/network';

import {
  SearchOutlined,
  FilterOutlined,
  EyeOutlined,
  WarningOutlined,
  ClearOutlined
} from '@ant-design/icons-vue';
import { useStore } from 'vuex';
import {
  FETCH_TABLE_MASSIVE_TICKETS,
  GETTER_GROUPS_TICKET_TABLE_ROWS,
  GETTER_GROUPS_TICKET_TABLE_TOTAL_PAGES,
  GETTER_GROUPS_TICKET_TABLE_ITEMS_PER_PAGE,
  GETTER_GROUPS_TICKET_TABLE_CURRENT_PAGE,
  GET_ALL_COMPANIES,
  FETCH_ALL_COMPANIES,
  TICKET_GROUPS_FETCH_MOVEMENT_FILES,
  TICKET_GROUPS_GET_MOVEMENT_FILES,
  TICKET_GROUPS_GET_LOADING,
  TICKET_GROUPS_FETCH_PROCESSED_FILES,
  FETCH_ALL_BROKERS,
  GET_ALL_BROKERS
} from '../../store/types';
import rutHelper from '../../utils/Ruts';
import tag from '../massive-tags.vue';

export default {
  name: 'MassiveTable',
  components: {
    'search-outlined': SearchOutlined,
    'filter-outlined': FilterOutlined,
    'eye-outlined': EyeOutlined,
    'warning-outlined': WarningOutlined,
    'clear-outlined': ClearOutlined,
    tag,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    }
  },
  props: {
    type: String,
    dates: Object
  },
  setup(props) {
    // * Tipo de ticket
    const ticketType = computed(() => props.type);
    let ro = null;

    // * VUEX
    const store = useStore();

    // * Vue router ### (1) ###
    const route = useRoute();
    const router = useRouter();
    const formRef = ref();
    const validError = ref();

    const scrollTop = ref(null);
    const scrollBottom = ref(null);
    const tableScrollWidth = ref(0);

    watch(
      () => route.fullPath,
      async (newPath) => {
        loadingTable.value = true;
        try {
          await store.dispatch(
            FETCH_TABLE_MASSIVE_TICKETS,
            `type=${props.type}&${newPath.split('?')[1] ?? ''}`
          );
        } catch (error) {
          console.log(error);
        }
      }
    );

    // * Redireccion al momento de hacer un filtro ### (3) ###
    const filterValues = ref({}); // Objeto que guarda los valores de los filtros
    const searchValue = ref({}); // Objeto que guarda los valores de los cuales se hace la busqueda por filtro

    const deleteParamForRedirection = (key) => {
      delete searchValue.value[key];
    };

    const getTableBody = () => {
      return (
        scrollBottom.value?.querySelector('.ant-table-body') ||
        scrollBottom.value?.querySelector('.ant-table-content') ||
        scrollBottom.value?.querySelector('.ant-table-container')
      );
    };

    const updateScrollWidth = () => {
      const tableBody = getTableBody();
      if (!tableBody) return;

      tableScrollWidth.value = Math.max(
        tableBody.scrollWidth,
        tableBody.clientWidth
      );
    };

    const syncScrollBottom = () => {
      const tableBody = getTableBody();
      if (!tableBody || !scrollTop.value) return;

      scrollTop.value.scrollLeft = tableBody.scrollLeft;
    };

    const syncScrollTop = () => {
      const tableBody = getTableBody();
      if (!tableBody) return;

      tableBody.scrollLeft = scrollTop.value.scrollLeft;
    };

    onBeforeUnmount(() => {
      const tableBody = getTableBody();

      if (tableBody) {
        tableBody.removeEventListener('scroll', syncScrollBottom);
      }

      if (ro && tableBody) {
        ro.unobserve(tableBody);
      }

      ro = null;
    });

    const addParamForRedirection = (key, param) => {
      if (key == 'companyRut' || key == 'employeeRut') {
        searchValue.value[key] = rutHelper.normalizeRut(param);
      } else {
        searchValue.value[key] = param;
      }

      if (key != 'page') {
        searchValue.value['page'] = 1;
      }
    };

    // Cuando se use un filtro de hace una redireccion de la página
    const filterRedirectionNewParam = () => {
      formRef.value
        .validate()
        .then(() => {
          router.replace({
            name:
              props.type === 'Alta'
                ? 'Altas'
                : props.type === 'Baja'
                ? 'Bajas'
                : props.type === 'Alta cargas'
                ? 'AltasCargas'
                : props.type === 'Baja cargas'
                ? 'BajasCargas'
                : 'Modificaciones',
            query: searchValue.value,
            hash: '#massive'
          });
        })
        .catch((error) => {
          if (error.errorFields?.length === 0) {
            // No hay errores reales, continuar como si estuviera validado
            router.replace({
              name:
                props.type === 'Alta'
                  ? 'Altas'
                  : props.type === 'Baja'
                  ? 'Bajas'
                  : props.type === 'Alta cargas'
                  ? 'AltasCargas'
                  : props.type === 'Baja cargas'
                  ? 'BajasCargas'
                  : 'Modificaciones',
              query: searchValue.value,
              hash: '#massive'
            });
          } else {
            console.log('Ha entrado al error');
            console.log('error', error);
            validError.value = error;
          }
        });
    };
    const formatRuts = () => {
      if (filterValues.value['companyRut']) {
        filterValues.value['companyRut'] = rutHelper.formatRut(
          filterValues.value['companyRut']
        );
      }
    };

    // Redireccion reseteando o sacando un parametro
    const filterRedirectionResetColumn = (key) => {
      delete searchValue.value[key];
      //Modificar luego de entender
      router.replace({
        name:
          props.type === 'Alta'
            ? 'Altas'
            : props.type === 'Baja'
            ? 'Bajas'
            : props.type === 'Alta cargas'
            ? 'AltasCargas'
            : props.type === 'Baja cargas'
            ? 'BajasCargas'
            : 'Modificaciones',
        query: searchValue.value,
        hash: '#massive'
      });
    };

    // * Filtros de las columnas con las rutas cambiantes ### (5) ###
    // Tabla
    const tableColumns = [
      {
        width: 100,
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Holding',
        dataIndex: 'holding',
        key: 'holding',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Subholding',
        dataIndex: 'subHolding',
        key: 'subHolding',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'Razón social',
        dataIndex: 'companyId',
        key: 'companyId',
        slots: {
          filterDropdown: 'filterCompanies',
          filterIcon: 'filterIcon'
        }
      },
      {
        width: 150,
        title: 'RUT empresa',
        dataIndex: 'companyRut',
        key: 'companyRut',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },

      ...(props.type !== 'Modificacion'
        ? [
            {
              width: 150,
              title: 'Póliza',
              dataIndex: 'policies',
              key: 'policies',
              slots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            },
            {
              width: 175,
              title: 'Grupo',
              dataIndex: 'groupCompanies',
              key: 'groupCompanies',
              slots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            },
            {
              width: 150,
              title: 'Estado',
              dataIndex: 'ticketGroupState',
              key: 'ticketGroupState',
              slots: {
                customRender: 'stateTag',
                filterDropdown: 'filterStates',
                filterIcon: 'filterIconState'
              }
            },
            {
              width: 150,
              title: 'Creados',
              dataIndex: 'ticketStatesCount.created',
              key: 'ticketStatesCount.created'
            },
            {
              width: 150,
              title: 'En bewell',
              dataIndex: 'ticketStatesCount.reviewBewell',
              key: 'ticketStatesCount.reviewBewell'
            },
            {
              width: 150,
              title: 'En aseguradora',
              dataIndex: 'ticketStatesCount.reviewInsuranceCompany',
              key: 'ticketStatesCount.reviewInsuranceCompany'
            },
            {
              width: 150,
              title: 'Cancelados',
              dataIndex: 'ticketStatesCount.canceled',
              key: 'ticketStatesCount.canceled'
            },
            {
              width: 150,
              title: 'Ejecutados',
              dataIndex: 'ticketStatesCount.executed',
              key: 'ticketStatesCount.executed'
            }
          ]
        : [
            {
              width: 150,
              title: 'Estado',
              dataIndex: 'ticketGroupState',
              key: 'ticketGroupState',
              slots: {
                customRender: 'tag',
                filterDropdown: 'filterStates',
                filterIcon: 'filterIconState'
              }
            }
          ]),
      {
        width: 150,
        title: 'Ejecutivo',
        dataIndex: 'brokerId',
        key: 'brokerId',
        slots: {
          filterDropdown: 'filterBrokers',
          filterIcon: 'filterIconState'
        }
      },

      {
        width: 95,
        fixed: 'right',
        align: 'center',
        title: 'Acción',
        dataIndex: 'id',
        key: 'id',
        slots: {
          customRender: 'details'
        }
      }
    ];

    const modalProps = reactive({
      title: '',
      visible: false,
      loading: false,
      mode: 'create'
    });

    const observationColumns = ref([
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Empresa',
        dataIndex: 'company',
        key: 'company'
      },
      {
        title: 'Aseguradora',
        dataIndex: 'insuranceCompany',
        key: 'insuranceCompany'
      },
      {
        title: 'Fecha de ingreso',
        dataIndex: 'createdAt',
        key: 'createdAt'
      },
      {
        title: 'Ejecutivo',
        dataIndex: 'broker',
        key: 'broker'
      },
      {
        title: 'Archivo original',
        dataIndex: 'fileMovement',
        key: 'fileMovement',
        slots: { customRender: 'downloadRender' }
      },
      {
        title: 'Reporte',
        dataIndex: 'fileMovementProcess',
        key: 'fileMovementProcess',
        slots: { customRender: 'downloadReportRender' }
      },
      {
        title: 'N° observaciones',
        dataIndex: 'numberOfObservations',
        key: 'numberOfObservations',
        slots: { customRender: 'observationsRender' }
      }
    ]);

    const loadingMovementFile = ref(false);
    const loadingMovementFileProcess = ref(false);

    const formatFileName = (text, maxLength = 35) => {
      if (!text) return '';
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const downloadMovementFile = (id) => {
      loadingMovementFile.value = true;
      try {
        const url = getMovementFile(id);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'archivo_original.xlsx';
        link.click();
      } catch (e) {
        console.error(
          'Error al formar la URL o descargar archivo original:',
          e
        );
      } finally {
        loadingMovementFile.value = false;
      }
    };

    const downloadMovementProcessedFile = (id) => {
      loadingMovementFileProcess.value = true;
      try {
        const url = getMovementProcessedFile(id);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'reporte.xlsx';
        link.click();
      } catch (e) {
        console.error('Error al formar la URL o descargar reporte:', e);
      } finally {
        loadingMovementFileProcess.value = false;
      }
    };

    const total = computed(() => {
      return store.getters[GETTER_GROUPS_TICKET_TABLE_TOTAL_PAGES];
    });

    // Items por página
    const itemsPerPage = computed(() => {
      return store.getters[GETTER_GROUPS_TICKET_TABLE_ITEMS_PER_PAGE];
    });

    // Pagina en la que nos encontramos
    const currentPage = computed(() => {
      return store.getters[GETTER_GROUPS_TICKET_TABLE_CURRENT_PAGE];
    });

    const paginationProps = reactive({
      total,
      pageSize: itemsPerPage,
      current: currentPage
    });

    const observationsTableData = computed(() => {
      const data = store.getters[TICKET_GROUPS_GET_MOVEMENT_FILES];
      return data ? [data] : [];
    });

    const tableData = computed(() => {
      return store.getters[GETTER_GROUPS_TICKET_TABLE_ROWS].map((obj) => {
        return {
          id: obj.id,
          key: obj.id,
          holding: obj.holding,
          companyId: obj.company.name,
          companyRut: rutHelper.formatRut(obj.company.rut),
          subHolding: obj.subHolding,
          policies: obj.policies.join(', '),
          groupCompanies: obj.groupCompanies.join(', '),
          ticketStatesCount: obj.ticketStatesCount,
          brokerId: obj.broker?.name,
          ticketCount: obj.count,
          ticketGroupState: {
            id: obj.ticketGroupState.id,
            text: obj.ticketGroupState.tag
          },
          hasObservations: false
        };
      });
    });

    const loadingTable = ref(false);

    watch(
      () => tableData.value,
      async (newData) => {
        loadingTable.value = true;
        await fetchObservationsForTable(newData);
        loadingTable.value = false;
      }
    );

    const fetchObservationsForTable = async (rows) => {
      if (!rows.length) return;
      try {
        const processedFilesByTicketGroupId = await store.dispatch(
          TICKET_GROUPS_FETCH_PROCESSED_FILES,
          rows.map((row) => row.id)
        );
        rows.forEach((row) => {
          const file = processedFilesByTicketGroupId[row.id];
          row.hasObservations = file?.numberOfObservations > 0;
        });
      } catch (e) {
        console.error('Error cargando observaciones para la tabla:', e);
        rows.forEach((row) => {
          row.hasObservations = false;
        });
      }
    };

    const movementFilesData = computed(() => {
      return store.getters[TICKET_GROUPS_GET_MOVEMENT_FILES];
    });

    const loadingMovementFiles = computed(() => {
      return store.getters[TICKET_GROUPS_GET_LOADING].fetchMovementFiles;
    });

    const getMovementFiles = async (ticketGroupId) => {
      try {
        await store.dispatch(TICKET_GROUPS_FETCH_MOVEMENT_FILES, ticketGroupId);
      } catch (e) {
        console.error('Error:', e);
      }
    };

    const openObservationsModal = async (record) => {
      modalProps.loading = true;
      await getMovementFiles(record.id);
      modalProps.mode = 'create';
      modalProps.title = 'Observaciones';
      modalProps.visible = true;
      modalProps.loading = false;
    };

    const closeObservationsModal = () => {
      modalProps.visible = false;
    };

    const changeCurrentPage = (page) => {
      addParamForRedirection('page', page.current);
      filterRedirectionNewParam();
    };

    // Seleccion de estados
    const statesSelection = ref([]);

    const filteredStates = ref([]);

    const statesOptions = computed(() => {
      return filteredStates.value.map((state) => ({
        label: state.fullTag || state.tag,
        value: state.id
      }));
    });

    // Busqueda por columna
    const handleSearch = (column, value, confirm) => {
      if (value != '' && value != undefined) {
        // Hago la redireccion con el nuevo valor
        addParamForRedirection(column, value);
        filterRedirectionNewParam();
        // Hago que se cierre el mini modal de busqueda
        confirm();
      }

      if (searchValue.value[column]) {
        formRef.value
          .validate()
          .then(() => {
            addParamForRedirection(column, value);
            filterRedirectionNewParam();
            confirm();
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
      if (value == undefined || value == '') {
        formRef.value.clearValidate();
      }
    };

    // Limpiar columna
    const handleColumnReset = (column, resetConfirm) => {
      filterRedirectionResetColumn(column);
      resetConfirm();
      delete filterValues.value[column];
      if (column == 'companyRut') {
        formRef.value.resetFields();
        formRef.value.clearValidate();
      }

      if (column === 'ticketGroupState') {
        statesSelection.value = [];
      }

      if (column === 'companyId') {
        selectedCompanies.value = [];
      }

      if (column === 'brokerId') {
        selectedBrokers.value = [];
      }
    };

    // Clear all column filters (dates come from the external picker and are kept)
    const externalFilterKeys = ['page', 'startDate', 'endDate'];

    const hasActiveFilters = computed(() =>
      Object.keys(route.query).some((key) => !externalFilterKeys.includes(key))
    );

    const clearAllFilters = () => {
      Object.keys(filterValues.value).forEach((key) => {
        delete filterValues.value[key];
      });
      Object.keys(searchValue.value)
        .filter((key) => !['startDate', 'endDate'].includes(key))
        .forEach((key) => {
          delete searchValue.value[key];
        });

      statesSelection.value = [];
      selectedCompanies.value = [];
      selectedBrokers.value = [];
      formRef.value?.clearValidate();

      router.replace({
        name: route.name,
        query: { ...searchValue.value },
        hash: '#massive'
      });
    };

    // Busqueda por estado
    const stateTicketSearchFilter = (states, confirm) => {
      addParamForRedirection('state', states.join(','));
      filterRedirectionNewParam();
      confirm();
    };

    // * Selector por compania
    /*
    Como el selector de compania tiene que ver en conjunto a la parte del dashboard donde el usuario tiene que selecccionar que
    companias van a aparecer filtradas antes de entrar, va a tener una logica dintinta a las demas selecciones y va a ser de este estilo
    */
    const getCompaniesList = async () => {
      try {
        store.dispatch(FETCH_ALL_COMPANIES);
      } catch (error) {
        console.log(error);
      }
    };

    const selectedCompanies = ref([]);
    const companies = computed(() => {
      return store.getters[GET_ALL_COMPANIES].map((obj) => {
        return {
          value: obj.id,
          label: obj.businessName
        };
      });
    });

    const getBrokersList = async () => {
      try {
        store.dispatch(FETCH_ALL_BROKERS);
      } catch (error) {
        console.log(error);
      }
    };

    const selectedBrokers = ref([]);
    const brokers = computed(() => {
      return store.getters[GET_ALL_BROKERS].map((obj) => {
        return {
          value: obj.id,
          label: obj.name
        };
      });
    });

    // * Filtro de fecha desde afuera
    watch(
      () => props.dates,
      (new_val) => {
        if (new_val[0] != undefined && new_val[1] != undefined) {
          addParamForRedirection('startDate', new_val[0]);
          addParamForRedirection('endDate', new_val[1]);
        } else {
          deleteParamForRedirection('startDate');
          deleteParamForRedirection('endDate');
        }

        filterRedirectionNewParam();
      }
    );

    watch(filterValues.value, (value) => {
      if (value.companyRut == '') {
        formRef.value.clearValidate();
      }
    });

    // * Recarga de página, obtencion de los valores de la url a filtros ### (4) ###
    onMounted(async () => {
      // Voy a obtener la lista de companias para el selector mismo
      getCompaniesList();
      getBrokersList();

      getTicketGroupStates().then((response) => {
        filteredStates.value = response.data.filter((s) =>
          [1, 6].includes(s.id)
        );
      });

      // Al momento de cargar la página, voy a ver que parametros vienen, con eso voy a dejar los valores de cada uno de los filtros realizados ahi
      const keys = Object.keys(route.query);

      keys.forEach((element) => {
        filterValues.value[element] = route.query[element]; // Le paso valor al los inputs para que muestre que es lo que busco anteriormente
        searchValue.value[element] = route.query[element]; // Le paso valor al objeto de la busqueda en caso de hacer otra consulta

        // en caso de que el filtro que venga sea 'State', voy a dejar selecciadas las casillas checkbox
        if (element === 'state') {
          statesSelection.value.push(
            ...route.query[element].split(',').map((e) => parseInt(e))
          );
        }

        // en caso de que el filtro que venga sea 'companyId', voy a dejar selecciadas las casillas checkbox
        if (element === 'companyId') {
          selectedCompanies.value.push(
            ...route.query[element].split(',').map((e) => parseInt(e))
          );
        }

        if (element === 'brokerId') {
          selectedBrokers.value.push(
            ...route.query[element].split(',').map((e) => parseInt(e))
          );
        }
      });

      loadingTable.value = true;
      try {
        await store.dispatch(
          FETCH_TABLE_MASSIVE_TICKETS,
          `type=${props.type}&${
            route.fullPath.split('?')[1] != undefined
              ? route.fullPath.split('?')[1]
              : ''
          }`
        );
        loadingTable.value = false;

        await nextTick();

        setTimeout(() => {
          updateScrollWidth();

          const tableBody = getTableBody();
          if (!tableBody) return;

          tableBody.addEventListener('scroll', syncScrollBottom);

          ro = new ResizeObserver(() => {
            updateScrollWidth();
          });
          ro.observe(tableBody);
        }, 50);
      } catch (error) {
        console.log(error);
      }
    });
    const checkRut = async (rule, value) => {
      if (!value) {
        return;
      }
      if (!rutHelper.validateRut(value)) {
        return Promise.reject('RUT no válido');
      }
      return Promise.resolve();
    };
    const checkId = async (rule, value) => {
      if (!value) {
        return Promise.resolve();
      }
      if (!/^[1-9]\d*$/.test(String(value).trim())) {
        return Promise.reject('Id no válido');
      }
      return Promise.resolve();
    };
    const rules = {
      id: [
        {
          required: false,
          validator: checkId,
          trigger: 'change'
        }
      ],
      companyRut: [
        {
          required: false,
          validator: checkRut,
          trigger: 'change'
        }
      ]
    };

    return {
      filterValues,
      searchValue,
      tableColumns,
      tableData,
      handleColumnReset,
      handleSearch,
      filterRedirectionNewParam,
      paginationProps,
      changeCurrentPage,
      statesSelection,
      statesOptions,
      stateTicketSearchFilter,
      hasActiveFilters,
      clearAllFilters,
      companies,
      selectedCompanies,
      ticketType,
      formRef,
      validError,
      formatRuts,
      rules,
      openObservationsModal,
      closeObservationsModal,
      modalProps,
      observationColumns,
      loadingMovementFiles,
      movementFilesData,
      observationsTableData,
      downloadMovementFile,
      downloadMovementProcessedFile,
      formatFileName,
      loadingTable,
      brokers,
      selectedBrokers,
      scrollTop,
      scrollBottom,
      tableScrollWidth,
      syncScrollTop,
      updateScrollWidth
    };
  }
};
</script>
<style scoped>
.scroll-top {
  height: 18px;
  margin-bottom: 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  border-radius: 6px;
}

.scroll-content {
  height: 1px;
}
</style>
